import validate from "./validation";


export const requiredElements = [];

const submitButton = $('#saveButton');
const submitWarning = $('#submitWarning');
const submitLoader = $('#submitLoader');
let k_month, k_posted, k_files, k_bank;

const createDropdowns = async () => {
  k_bank = $('#Bank').kendoDropDownList({
    optionLabel: 'Select bank...',
    index: -1,
    value: ''
  }).data('kendoDropDownList');
  requiredElements.push({
    name: 'Bank',
    element: k_bank
  });
};

const createDatePickers = async () => {
  const lastMonth = new Date();
  lastMonth.setMonth(lastMonth.getMonth() - 1);
  k_month = $('#LastDayOfMonth').kendoDatePicker({
    componentType: 'modern',
    depth: 'year',
    start: 'year',
    format: '{0:MMMM yyyy}',
    dateInput: true,
    value: kendo.date.lastDayOfMonth(lastMonth)
  }).data('kendoDatePicker');
  k_posted = $('#PostDate').kendoDatePicker({
    componentType: 'modern',
    dateInput: true,
    value: new Date()
  }).data('kendoDatePicker');
  requiredElements.push({
    name: 'Month',
    element: k_month
  });
  requiredElements.push({
    name: 'Post Date',
    element: k_posted
  });
};

const createFileUpload = async () => {
  k_files = $('#files').kendoUpload({
    async: {
      autoUpload: false,
      saveUrl: 'CheckFile'
    },
      validation: {allowedExtensions: ['.csv', '.txt', '.RCN', '.xlsx']},
    multiple: true,
    dropZone: '#filesDrop'
  }).data('kendoUpload');
  requiredElements.push({
    name: 'Files to Process',
    element: k_files
  });
  $('.k-widget.k-upload').addClass('k-hide-upload');
};

const process = (e) => {
  if(!validate(requiredElements)) {
    submitWarning.text('Missing required fields');
    submitWarning.show();
    return;
  }
  submitButton.prop('disabled', true);
  submitLoader.show();
  const formData = new FormData();
  formData.append('LastDayOfMonth', k_month.value().toUTCString());
  formData.append('Posted', k_posted.value().toUTCString());
  formData.append('Bank', k_bank.value());
  k_files.getFiles().forEach((e, i) => {
    formData.append(`Files`, e.rawFile);
  });
  $.post({
    url: '/Finance/CheckRecon/ProcessFiles',
    data: formData,
    processData: false,
      contentType: false
  }).done(resp => {
    const {bank, downloadName, downloadLink} = resp;
    const aTag = $(`<a><span class="k-icon k-i-download" style="margin-right: 4px;"></span>Re-download ${bank} file</a>`);
    const dZone = $('#download-zone');
    aTag.prop('target', '_blank');
    aTag.prop('download', downloadName);
    aTag.prop('href', downloadLink);
    aTag.addClass('k-button k-primary');
    aTag.appendTo(dZone);
    aTag[0].click();
    dZone.show();
    submitWarning.hide();
  }).fail(resp => {
    const {status,message} = resp.responseJSON;
    submitWarning.text(message);
    submitWarning.show();
    submitButton.prop('disabled', false);
  }).always(() => {
    submitLoader.hide();
  });
};

const setupSubmit = async () => {
  submitButton.on('click', process);
};

export default function() {
  submitLoader.hide();
  return Promise.allSettled([createDropdowns(), createDatePickers(), createFileUpload(), setupSubmit()]);
}
